import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import User from '../users/User';
import { v4 as uuidv4 } from 'uuid';

class PerformanceReviewNote extends DomainObject {
  id = uuidv4();
  text;
  lexicalState;
  visibleToReviewee = false;
  createdByUser;

  _relations = {
    createdByUser: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      text: observable,
      lexicalState: observable,
      visibleToReviewee: observable,
      createdByUser: observable
    });

    this.merge(other);
  }
}

export default PerformanceReviewNote;
